"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsPaymentTypeValid = IsPaymentTypeValid;
const class_validator_1 = require("class-validator");
function IsPaymentTypeValid(validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "IsPaymentTypeValid",
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: {
                validate(value) {
                    return value === "partner";
                },
            },
        });
    };
}
//# sourceMappingURL=IsPaymentTypeValid.js.map